// extracted by mini-css-extract-plugin
export default {"languageInput":"SelectLanguageModalContent-languageInput-qv4lb"};